import { z } from 'zod';

export const OIDC_PROVIDER_PREFIX = 'oidc:';

export const LoginOptions = {
  USER_PASSWORD: 'usuario-e-senha',
  MAGIC_LINK: 'link-no-email',
  GOOGLE_SOCIAL: 'google',
  MICROSOFT_SOCIAL: 'microsoft',
};
export const LoginOptionsTypes = {
  USER_PASSWORD: 'usuario-e-senha',
  MAGIC_LINK: 'link-no-email',
  GOOGLE_SOCIAL: 'google',
  MICROSOFT_SOCIAL: 'microsoft',
} as const;
export const AllLoginOptions = Object.values(LoginOptions);
export const AllLoginOptionsTypes = Object.values(LoginOptionsTypes);
export const officeLoginConfigSchema = z.object({
  allowed_methods: z.array(z.string()),
  isMagicLink: z.boolean().optional(),
  password_expiration_days: z.number().int().min(20).optional(),
  max_wrong_login_attempts: z.number().int().min(1).optional(),
});

export type OfficeLoginConfig = z.infer<typeof officeLoginConfigSchema> & {
  allowed_methods: string[];
};

const defaultValue: OfficeLoginConfig = {
  allowed_methods: AllLoginOptions,
  max_wrong_login_attempts: 10,
  password_expiration_days: 10,
};

export const officeLoginConfigDefaultValue = JSON.stringify(defaultValue, null, '\t');
